import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import httpInjectorService from 'services/http-injector.service';
import wfhImgEmpty from '../../../../assets/img/dashboards/office-amico.png';
import wfhImgActive from '../../../../assets/img/dashboards/At-the-office-bro.png'; // replace with appropriate remote work image
import { DemoWFHEmployees } from 'components/demodata/Dummydata';

// ---------- WFH List ----------
const WfhList = ({ members, fallback }) => {
  const [expanded, setExpanded] = useState(false);
  const limit = 3;

  if (members?.length > 0) {
    const visibleMembers = expanded ? members : members.slice(0, limit);

    return (
      <div className="mt-2">
        <div className="d-flex flex-wrap gap-2">
          {visibleMembers.map((m) => (
            <span
              key={m.wfh_id || m.user_id}
              className="badge text-white p-2"
              style={{
                fontSize: '0.8rem',
                borderRadius: '12px',
                backgroundColor: 'purple',
              }}
            >
              {m.username}
            </span>
          ))}

          {members.length > limit && (
            <button
              type="button"
              className="badge bg-light text-dark border p-2"
              style={{
                fontSize: '0.8rem',
                borderRadius: '12px',
                cursor: 'pointer',
              }}
              onClick={() => setExpanded((prev) => !prev)}
            >
              {expanded ? 'Show less' : `+${members.length - limit} more`}
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <p className="card-text mt-3">
      {fallback.split('\n').map((line, i) => (
        <React.Fragment key={i}>
          {line}
          <br />
        </React.Fragment>
      ))}
    </p>
  );
};

WfhList.propTypes = {
  members: PropTypes.array,
  fallback: PropTypes.string.isRequired,
};

// ---------- RemoteCard ----------
function RemoteCard() {
  const [wfhMembers, setWfhMembers] = useState([]);
  const [image, setImage] = useState(wfhImgEmpty);
  const [content, setContent] = useState(
    'Everyone is at office!\nNo one is working remotely today.',
  );

  const getTodaysWfhMembers = useCallback(async () => {
    try {
        const isDemoMode = localStorage.getItem("demoMode") === "true";
            
        if (isDemoMode) {
          setWfhMembers(DemoWFHEmployees);
          return;
        }
      const response = await httpInjectorService.getTodaysWfhMembers(
        // '/api/dashboard/today-wfh-members',
      );
      const data = response.status === 'success' ? response.data : [];

      setWfhMembers(data);
      setImage(data.length > 0 ? wfhImgActive : wfhImgEmpty);
      setContent(
        data.length === 0
          ? 'Everyone is at office!\nNo one is working remotely today.'
          : null,
      );
    } catch (err) {
      console.error('Failed to fetch WFH members', err);
      setContent('Unable to fetch WFH members today.');
      setWfhMembers([]);
      setImage(wfhImgEmpty);
    }
  }, []);

  useEffect(() => {
    getTodaysWfhMembers();
  }, [getTodaysWfhMembers]);

  return (
    <div className="mt-3">
      <div className="shadow-md p-3 rounded bg-white">
        <div className="row">
          <span className="card-title fw-bold">Working Remotely</span>
          <div className="col-6">
            <WfhList members={wfhMembers} fallback={content} />
          </div>
          <div className="col-6 d-flex justify-content-center">
            <img
              src={image}
              alt="Remote Work"
              style={{ height: 100, width: 100 }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RemoteCard;
